import { createFileRoute } from '@tanstack/react-router';
import { ProjectsHead } from '@/features/projects/ui/ProjectsHead';
import { SHEET_TABS } from '@/features/sync/sheetTabConfigs';
import { SyncDetailPage } from '@/features/sync/SyncDetailPage';

export const Route = createFileRoute('/_authenticated/projects/sync/$id')({
  component: function ProjectsSyncDetail() {
    const { id } = Route.useParams();
    return (
      <div className="flex flex-col gap-4">
        <ProjectsHead subtitle="Chi tiết lần gửi duyệt" />
        <SyncDetailPage config={SHEET_TABS.projects} id={id} />
      </div>
    );
  },
});
